import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";
import styled from "styled-components";

function ConvencionColores({
  tipo,
}: {
  tipo: "NIVELES_OCUPACION" | "TIPOS_RESERVA";
}) {
  const [animationParent] = useAutoAnimate<HTMLDivElement>();

  return (
    <div className="mb-2">
      <div className="mb-2">
        <b>
          {tipo === "NIVELES_OCUPACION"
            ? "Niveles de ocupación:"
            : "Tipos de reserva"}
        </b>
      </div>
      <div className="d-flex justify-content-start" style={{ gap: "16px" }} ref={animationParent}>
        {tipo === "NIVELES_OCUPACION" && (
          <>
            <div className="d-flex" style={{ gap: "8px" }}>
              <div>Bajo:</div>
              <ColorVerde />
            </div>
            <div className="d-flex" style={{ gap: "8px" }}>
              <div>Medio:</div>
              <ColorAmarillo />
            </div>
            <div className="d-flex" style={{ gap: "8px" }}>
              <div>Alto:</div>
              <ColorRojo />
            </div>
          </>
        )}
        {tipo === "TIPOS_RESERVA" && (
          <>
            <div className="d-flex" style={{ gap: "8px" }}>
              <div>Guarderia:</div>
              <ColorAzul />
            </div>
            <div className="d-flex" style={{ gap: "8px" }}>
              <div>Hotel:</div>
              <ColorRojo />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const ColorVerde = styled("div")`
  background-color: ${(props) => props.theme.colors.successShadow};
  width: 64px;
  height: 32px;
`;

const ColorAmarillo = styled("div")`
  background-color: ${(props) => props.theme.colors.warningShadow};
  width: 64px;
  height: 32px;
`;

const ColorRojo = styled("div")`
  background-color: ${(props) => props.theme.colors.dangerShadow};
  width: 64px;
  height: 32px;
`;

const ColorAzul = styled("div")`
  background-color: ${(props) => props.theme.colors.blueShadow};
  width: 64px;
  height: 32px;
`;

export default ConvencionColores;
